import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../actions/userAction";

const Signout = ({ history }) => {
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  // console.log(history);

  // useEffect(() => {
  //   if (!userInfo) {
  //     window.location.href = "/login"
  //   }
  // }, [userLogin]);

  const clickHandle = (e) => {
    e.preventDefault();
    dispatch(logout());
    window.location.href = "/login";
  };

  return (
    <div style={{ whiteSpace: "nowrap" }} className="px-25 signout mt-5">
      <button onClick={clickHandle}>
        <i className="fas fa-sign-out-alt mr-2 font-normal"></i> Logout
      </button>
    </div>
  );
};

export default Signout;
